// src/components/Dashboard.tsx
import React, { useEffect, useState } from "react";
import axios from "axios";

interface User {
  name: string;
  email: string;
  photo: string;
}

const Dashboard: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    axios
      .get("http://13.202.240.253:5000/api/auth/user", { withCredentials: true })
      .then((res) => setUser(res.data));
  }, []);

  const logout = () => {
    axios
      .get("http://13.202.240.253:5000/api/auth/logout", { withCredentials: true })
      .then(() => {
        setUser(null);
        window.location.href = "/login-test";
      });
  };

  return (
    <div>
      <h1>Dashboard</h1>
      {user ? (
        <div>
          <img src={user.photo} alt="profile" />
          <h3>{user.name}</h3>
          <p>{user.email}</p>
          <button onClick={logout}>Logout</button>
        </div>
      ) : (
        <p>Not logged in</p>
      )}
    </div>
  );
};

export default Dashboard;
